import React from 'react'
import ReactTable from 'react-table'
import {Link} from 'react-router-dom'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import InfoIcon from '@material-ui/icons/Info';
import Edit from '@material-ui/icons/Edit'
import PictureAsPdf from '@material-ui/icons/PictureAsPdf'
import Button from '@material-ui/core/Button';
import stylePlatform from 'assets/css/style.jsx';
import api from 'api'
import {toLocaleString} from 'services/utils'
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Popover from '@material-ui/core/Popover';
import ImageIcon from '@material-ui/icons/Image';

const brands = [
    {
        value: 'VICHY',
        label: 'Vichy',
    },
    {
        value: 'SkinCeuticals',
        label: 'SkinCeuticals',
    },
    {
        value: 'LA-ROCHE-POSAY',
        label: 'La Roche-Posay',
    },
    {
        value: 'Sanoflore',
        label: 'Sanoflore',
    },
    {
        value: 'ROGER&GALLET',
        label: 'Roger & Gallet',
    },
    {
        value: 'CERAVE',
        label: 'CeraVe',
    },
];

const statusOperations = [
    {
        value: '1',
        label: 'En cours',
    },
    {
        value: '2',
        label: 'Conforme',
    },
    {
        value: '3',
        label: 'Non conforme (NC)',
    },
    {
        value: '4',
        label: 'Non conforme (NCT)',
    },
    {
        value: '5',
        label: 'Remboursement validé',
    },
    {
        value: '6',
        label: 'Participation modifiée',
    },
];

const tableConf = {
    previousText: 'Précédent',
    nextText: 'Suivant',
    loadingText: 'Chargement...',
    noDataText: 'Lignes non trouvées',
    pageText: 'Page',
    ofText: 'of',
    rowsText: 'lignes',
    sizeOptions: [10, 25, 50],
    defaultSize: 10,
    columns: [
        // {
        //     Header: '',
        //     accessor: 'operation',
        //     filterable: false,
        //     Cell: columnImage,
        //     sortable: false
        // },
        // {
        //     Header: 'Marque',
        //     accessor: 'operation.brand.name',
        //     filterable: false,
        // },
        {
            Header: 'Opération',
            accessor: 'operation.title',
            filterable: false
        },
        {
            Header: 'Statut opération',
            accessor: 'state.status',
            filterable: false
        },
        {
            Header: 'Date participation',
            accessor: 'createdAt',
            filterable: false
        },
        {
            Header: 'Date Virement',
            accessor: 'financialDate',
            filterable: false
        },
        {
            Header: 'Montant Virement',
            accessor: 'financialAmount',
            filterable: false
        },
        {
            Header: 'IBAN',
            accessor: 'customer.cachedIban',
            filterable: false
        },
        {
            Header: 'Fichier',
            accessor: 'file',
            sortable: false,
            filterable: false
        }
    ]
};

const stateButton = ['#2196f3', '#f8971d', '#4caf50', '#f44336', '#75d1e0', '#81c784', 'reddit']

class ConsumerRequestsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            openRecap: false,
            idPart: '',
            searchTitle:'',
            searchBrands:'',
            searchStatus:'',
            anchorEl:null,
            openedPopoverId: null
        };
        tableConf.columns[6].Cell = this.columnFile.bind(this);
    }

    handleClickRecap = (original) => {
        this.setState({openRecap: true});
        this.setState({idPart: original});
    };

    handleClose = () => {
        this.setState({openRecap: false});
    };
    onchange = e => {
        this.setState({ searchTitle: e.target.value, searchBrands:'', searchStatus:'' });
    };

    onchangeBrands = e => {
        this.setState({ searchBrands: e.target.value, searchTitle:'', searchStatus:'' });
    };

    onchangeStatus = e => {
        this.setState({ searchStatus: e.target.value, searchTitle:'', searchBrands:'' });
    };
    onChangeReset=()=>{
        this.setState({ searchStatus: '', searchTitle:'', searchBrands:'' });
    };

    handleClickPopover = (ticketId) => event => {
        this.setState({anchorEl:event.currentTarget, openedPopoverId: ticketId})
    };

    handleClosePopover = () => {
        this.setState({anchorEl:null,openedPopoverId:false})
    };

    fetchData = (state) => {
        const {classes} = this.props;
        const params = {
            page: state.page + 1,
            pageSize: state.pageSize,
            order: state.sorted.reduce((accumulator, currentValue) => {
                accumulator[currentValue.id] = currentValue.desc ? 'desc' : 'asc';
                return accumulator
            }, {}),
            filtered: state.filtered
        };

        this.setState({loading: true});

        api.operations.my_participations(params)
          .then((res) => {
              this.setState({
                  data: res.data['hydra:member'].map((prop) => {
                      return {
                          ...prop,
                          createdAt: toLocaleString(prop.createdAt).slice(0,10),
                          financialDate: toLocaleString(prop.financialDate),
                          state: {
                              ...prop.state,
                              status: (
                                <Button
                                  className={classes.actionButton}
                                  size='sm'
                                  style={{backgroundColor:stateButton[prop.state.id], color:'white', fontSize: '10px'}}
                                >
                                    {prop.state.status}
                                </Button>
                              )
                          }
                      };
                  }),
                  pages: Math.ceil(res.data['hydra:totalItems'] / state.pageSize),
                  loading: false
              })
          })
          .catch(error => {
              this.setState({
                  data: [],
                  loading: false
              })
          })
    }

    columnFile({original}) {
        const {classes} = this.props;
        let statusDefault = null;
        switch (this.state.idPart.state && this.state.idPart.state.id) {
            case 1:
                statusDefault = "En cours";
                break;
            case 2:
                statusDefault = "Conforme";
                break;
            case 3:
                statusDefault = "Non conforme (NC)";
                break;
            case 4:
                statusDefault = "Non conforme (NCT)";
                break;
            case 5:
                statusDefault = "Remboursement validé";
                break;
            case 6:
                statusDefault = "Participation modifiée";
                break;
            default:
        }

        return (

          <div className='actions-right'>
              {original.tickets.length > 0 &&
              <div>
                  <Button style={{float: 'right'}} round className={classes.btnEye + '' + classes.actionButtonRound}
                          onClick={this.handleClickPopover(original.id)}>
                      <RemoveRedEye/>
                  </Button>
                  <Popover
                    key={original.id}
                    id={original.id}
                    elevation={1}
                    open={this.state.openedPopoverId === original.id }
                    anchorEl={this.state.anchorEl}
                    onClose={this.handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                  >
                      {original.tickets.map((tickets, idx) =>(
                        <Button
                          round
                          onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/media/${tickets.contentUrl}`, '_blank')}
                          className={classes.actionButton + ' ' + classes.actionButtonRound + ' ' + classes.btnEye}
                        >
                            <ImageIcon/>
                        </Button>))}


                  </Popover>
              </div>
              }

            <Button round  onClick={event => this.handleClickRecap(original)} style={{color: "#1b9760"}} className={classes.actionButton + ' ' + classes.actionButtonRound}>
                <InfoIcon/>
            </Button>

            <Dialog open={this.state.openRecap} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
               <DialogTitle id="alert-dialog-title">Récapitulatif de ma participation</DialogTitle>
               <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      <List className={classes.root}>
                          <ListItem>
                              <ListItemText primary="Numéro de participation" secondary={this.state.idPart.code} />
                          </ListItem>
                          <ListItem>
                              <ListItemText primary="Opération" secondary={this.state.idPart.operation && this.state.idPart.operation.code + '-' + this.state.idPart.operation.title} />
                          </ListItem>
                          <ListItem>
                              <ListItemText primary="Date de participation" secondary={this.state.idPart.createdAt} />
                          </ListItem>
                          <ListItem>
                              <ListItemText primary="Motif de non conformité" secondary={this.state.idPart.reasonNotConformity && this.state.idPart.reasonNotConformity.length !== 0 ? this.state.idPart.reasonNotConformity[0].libelle_long : <Chip label="Aucun" />} />
                          </ListItem>
                          <ListItem>
                              <ListItemText primary="Statut" secondary={statusDefault} />
                              <ListItemText primary="IBAN" secondary={this.state.idPart.customer && this.state.idPart.customer.cachedIban} />
                          </ListItem>
                          <ListItem>
                              <ListItemText primary="Montant" secondary={this.state.idPart.financialAmount  ? this.state.idPart.financialAmount +'€' : <Chip label="Aucun" />} />
                              <ListItemText primary="Date de virement" secondary={this.state.idPart.financialDate  ? this.state.idPart.financialDate : <Chip label="Aucun" />} />
                          </ListItem>
                      </List>
                  </DialogContentText>
               </DialogContent>
               <DialogActions>
                  <Button onClick={this.handleClose} color="primary">Fermer</Button>
               </DialogActions>
            </Dialog>

              {(original.state.id === 4 && new Date(original.operation.closingDate) > new Date()) &&
              <Link to={{pathname:`/modifier-demande/${original.operation.id}/part/${original.id}`,state:{type:original.operation['@type']}}} >
                  <Button
                    round
                    color='info'
                    className={classes.actionButton + ' ' + classes.actionButtonRound}
                  >
                      <Edit/>
                  </Button>
              </Link>}
              {null !== original.financialAmount &&
              <Button
                round
                onClick={() => api.participation.get_refund_proof(original.id)}
                color='success'
                className={classes.actionButton + ' ' + classes.actionButtonRound}
              >
                  <PictureAsPdf/>
              </Button>}
          </div>
        )
    };

    render() {
        const {page, data, pages, loading,searchTitle, searchBrands, searchStatus} = this.state;
        const filteredCountries = data.filter(country => {
            if(searchTitle) {
                return country.operation.title.toLowerCase().indexOf(searchTitle.toLowerCase()) !== -1;
            }
            else if(searchBrands){
                return country.operation.brand.name.toLowerCase().indexOf(searchBrands.toLowerCase()) !== -1;
            }
            else if(searchStatus){
                let stringStateId = country.state.id.toString();
                return stringStateId.toLowerCase().indexOf(searchStatus.toLowerCase()) !== -1;
            }
            else if(searchStatus === '' ){
                return country.operation && country.operation.title.toLowerCase().indexOf(searchStatus.toLowerCase()) !== -1;
            }
        });


        return (
          <div>
              <div style={{marginBottom:'50px', display:'none',}}>
                  <label style={{verticalAlign: 'bottom', marginRight:'15px'}}>Choix de la marque</label>
                  <TextField style={{width:'150px'}} value={searchBrands} select label="Les marques" onChange={this.onchangeBrands}>
                      {brands.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                      ))}
                  </TextField>
                  <label style={{verticalAlign: 'bottom', marginRight:'15px'}}><SearchIcon/>Recherche</label>
                  <TextField id="standard-basic" label="Titre de l'opération" value={searchTitle} onChange={this.onchange} />
                  <label style={{verticalAlign: 'bottom', marginRight:'15px'}} >Statut opération</label>
                  <TextField style={{width:'150px'}} value={searchStatus} select label="Statut opération" onChange={this.onchangeStatus}>
                      {statusOperations.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                      ))}
                  </TextField>
                  <Button type ='submit' onClick={this.onChangeReset} style={{backgroundColor:'black', color:'white',verticalAlign: 'bottom', marginLeft:'15px', float: 'right', marginTop:'10px'}} variant="contained">Réinitialiser filtre</Button>
              </div>
              <ReactTable
            page={page}
            data={filteredCountries}
            pages={pages}
            previousText='Précédent'
            nextText='Suivant'
            loadingText='Chargement...'
            noDataText='Lignes non trouvées'
            pageText='Page'
            rowsText='lignes'
            manual
            loading={loading}
            pageSizeOptions={tableConf.sizeOptions}
            filterable
            columns={tableConf.columns}
            defaultPageSize={tableConf.defaultSize}
            showPaginationBottom
            className='-striped -highlight'
            onFetchData={(state, instance) => this.fetchData(state, instance)}
          />
          </div>
        )
    }
}

export default withStyles(stylePlatform)(ConsumerRequestsTable)



// WEBPACK FOOTER //
// ./src/views/Tables/ConsumerRequestsTable.jsx